import IRepresentativeRepository from 'domain/interfaces/repositories/IRepresentativeRepository'
import { Query } from 'domain/models/query'

export const readInstitutionsByRepresentativeQuery = (
  repository: IRepresentativeRepository,
  query?: Query,
) => {
  return repository.getInstitutionsByRepresentative(query)
}
